// extracted by mini-css-extract-plugin
export default {"payment-type":"PaymentMethod_payment-type__ufbu2"};